var map = {
	"./arabic.png": 13291,
	"./biology.png": 72086,
	"./calculus.png": 21167,
	"./english.png": 80709,
	"./franch.png": 36068,
	"./geometry.png": 61724,
	"./germany.png": 65148,
	"./history.png": 92679,
	"./logic.png": 77938,
	"./math.png": 93750,
	"./philosophy.png": 30967,
	"./physics.png": 64935,
	"./psychology.png": 17576,
	"./science.png": 90370,
	"./social.png": 41930,
	"./solid.png": 69972,
	"./statistics.png": 63982
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 44142;